import { get } from 'lodash';

export const userIsOnDepositForm = () =>
  !!window.location.pathname.includes('/deposit');
export const userFirstFunded = (user) => !!get(user, 'firstFunded', false);
export const userFirstTraded = (user) => !!get(user, 'firstTraded', false);
